"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAdminConsole = void 0;
const react_1 = require("react");
const web_socket_context_1 = require("../../../providers/web-socket/web-socket-context");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
function useAdminConsole() {
    const { client, subscribe, unsubscribe } = (0, react_1.useContext)(web_socket_context_1.WebsocketContext);
    const resultForm = (0, react_1.useRef)(null);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const handleSubmit = (0, event_callback_hook_1.useEventCallback)((values) => {
        var _a;
        setLoading(true);
        const resultSubscription = subscribe('/user/topic/script/execute/response', (message) => {
            unsubscribe(resultSubscription);
            unsubscribe(consoleSubscription);
            handleResultIncomming(message);
            setLoading(false);
        });
        const consoleSubscription = subscribe('/user/topic/script/execute/out', (message) => {
            handleConsoleIncomming(message);
        });
        (_a = client.current) === null || _a === void 0 ? void 0 : _a.publish({
            destination: '/app/script/execute/request',
            body: JSON.stringify(values),
            skipContentLengthHeader: true,
        });
    });
    const handleResultIncomming = (0, event_callback_hook_1.useEventCallback)((message) => {
        var _a, _b;
        const result = JSON.parse(message.body);
        if (result.error != null) {
            (_a = resultForm.current) === null || _a === void 0 ? void 0 : _a.setFieldValue('result', result.error);
        }
        else {
            (_b = resultForm.current) === null || _b === void 0 ? void 0 : _b.setFieldValue('result', JSON.stringify(result.result));
        }
    });
    const handleConsoleIncomming = (0, event_callback_hook_1.useEventCallback)((message) => {
        var _a, _b;
        const values = (_a = resultForm.current) === null || _a === void 0 ? void 0 : _a.getFieldValues();
        (_b = resultForm.current) === null || _b === void 0 ? void 0 : _b.setFieldValue('console', values.console + message.body);
    });
    const handleLogIncomming = (0, event_callback_hook_1.useEventCallback)((message) => {
        var _a, _b;
        const values = (_a = resultForm.current) === null || _a === void 0 ? void 0 : _a.getFieldValues();
        (_b = resultForm.current) === null || _b === void 0 ? void 0 : _b.setFieldValue('log', values.log + message.body);
    });
    const handleClear = (0, event_callback_hook_1.useEventCallback)(() => {
        var _a;
        (_a = resultForm.current) === null || _a === void 0 ? void 0 : _a.clearForm();
    });
    (0, react_1.useEffect)(() => {
        const subscription = subscribe('/topic/script/log', (message) => handleLogIncomming(message));
        return () => {
            unsubscribe(subscription);
        };
    }, [handleLogIncomming, subscribe, unsubscribe]);
    return {
        handleSubmit,
        handleClear,
        resultForm,
        loading,
    };
}
exports.useAdminConsole = useAdminConsole;
//# sourceMappingURL=admin-console-hook.js.map